// Types
import {
  RelationshipConfigResponse,
  EntityToEntityRelationshipConfigResponse,
  EntityToInstrumentRelationshipConfig as EntityToInstrumentRelationshipConfigResponse,
} from 'app/modules/relationships/types';
import { PaginatedRelationshipsPayload } from 'app/modules/relationships/types/requests';

export interface RelationshipsState {
  relationshipConfig: RelationshipConfigResponse;

  loadingRetrieveRelationshipConfig: boolean;

  entityToEntityRelationshipConfigs: EntityToEntityRelationshipConfigResponse[];
  entityToInstrumentRelationshipConfigs: EntityToInstrumentRelationshipConfigResponse[];
  loadingRetrieveRelationshipConfigs: boolean;

  entityRelatedEntitiesPaginationPayload: Partial<
    Omit<PaginatedRelationshipsPayload, 'filters'>
  >;
  entityRelatedInstrumentsPaginationPayload: Partial<
    Omit<PaginatedRelationshipsPayload, 'filters'>
  >;
  instrumentRelatedEntitiesPaginationPayload: Partial<
    Omit<PaginatedRelationshipsPayload, 'filters'>
  >;

  entityRelatedEntitiesFilters: {
    selectedConfigs: string[];
    direction: DirectionOptions;
  };
  entityRelatedInstrumentsFilters: { selectedConfigs: string[] };
  instrumentRelatedEntitiesFilters: { selectedConfigs: string[] };
}

export enum RelationshipConfigType {
  ENTITY_TO_ENTITY = 'ENTITY_TO_ENTITY',
  ENTITY_TO_INSTRUMENT = 'ENTITY_TO_INSTRUMENT',
}

export enum RelatedEntityDirectedness {
  TO = 'TO',
  FROM = 'FROM',
  UNDIRECTED = 'UNDIRECTED',
}

export enum DegreeType {
  ONE = 'ONE',
  MANY = 'MANY',
}

export enum RiskType {
  PROACTIVE = 'PROACTIVE',
  REACTIVE = 'REACTIVE',
}

export interface EditRelationshipFormValues {
  name: string;
  description: string;
  degree: DegreeType;
  relationship_id: string;
  risk_type: RiskType;
}

export type DirectionOptions = 'either' | 'directed' | 'undirected';

export type TableTypeOptions = 'entity' | 'instrument';
